define('shared/util/cardinalAjax',[
  '$',
  'Promise',
  'shared/page/env',
  'shared/remote/ajax',
  'shared/util/path/ResolverFactory'
], function(
  $,
  Promise,
  getEnv,
  ajax,
  PathResolverFactory
) {
  var ENDPOINT_BASE = {
    qa: 'https://qa-englishlive-systems.ef.com',
    uat: 'https://qa-englishlive-systems.ef.com',
    stg: 'http://stg-eflive.us-east-1.elasticbeanstalk.com',
    live: 'https://englishlive-systems.ef.com',
  };

  function cardinalAjax(url, method, data, endpointFalse) {
      return getEnv()
        .then(function(env) {
          var endpointBase = "";
          if (typeof endpointFalse == "undefined") {
            endpointBase = ENDPOINT_BASE[env];
          }
          ajaxConfig = {
            type: method,
            url: endpointBase + url,
            crossDomain: true
          };
          if (typeof data != "undefined") {
            ajaxConfig.data = data;
          }

          return ajax(ajaxConfig);
        });
    }

    return cardinalAjax;
});

